<script>
import { allowedFileTypes, checkFileType } from '@/helpers/fileUploader.js'
export default {
  props: {
    letterCategory: { type: String },
    multiple: { type: Boolean }
  },
  data: vm => ({
    dragging: false,
    allowedFileTypes: allowedFileTypes,
    toolTip: vm.$t( 'component.upload.dropzone.info.' + vm.letterCategory + '.upload')
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    dropzoneText() {
      return this.$t('component.upload.dropzone.choose.' + this.letterCategory +
          '.letter' + (this.isMobile ? '.mobile' : ''))
    }
  },
  methods: {
    onDragOver(e) {
      if (e.dataTransfer.items) {
        const items = e.dataTransfer.items
        for (var i = 0; i < items.length; i++) {
          // If dropped items aren't files, reject them
          // otherwise show hover-effect and allow drop
          if (items[i].kind === 'file' && checkFileType(items[i].type)) {
            this.dragging = true
          } }}
    },
    onDrag(e) {
      this.emitDroppedFiles(e.dataTransfer.files)
    },
    onSelect(e) {
      this.emitDroppedFiles(e.target.files)
    },
    emitDroppedFiles(droppedFiles) {
      this.$emit('dropped', droppedFiles)
    },

    // reset targets event-value
    // fixed 'onchanged' not triggered after upload-dialog was canceled
    reset(event) {
      event.target.value = ''
    }
  }
}
</script>
<template>
  <v-card
    v-cloak
    :class="['mx-1 vue-dropzone', dragging ? 'dragenterClass' : '']"
    @dragover="onDragOver"
    @dragleave="dragging = false"
    @drop="dragging = false"
    @drop.prevent="onDrag"
    @dragover.prevent
    @click="$refs.files.click()">
    <input
      :id="letterCategory + 'Files'"
      ref="files"
      type="file"
      class="input-field primary d-none"
      :accept="allowedFileTypes"
      :multiple="multiple"
      @change="onSelect"
      @click="reset" />
    <v-card-title class="primary--background my-4">
      <v-tooltip slot="append" bottom top>
        <template #activator="{ on }">
          <v-row class="justify-center text-center" v-on="on">
            <v-col cols="12" class="pa-0">
              <span class="getDropZoneText">{{ dropzoneText }}</span>
              <br />
              <v-icon v-if="isMobile" class="mobile-btn-bottom"
              >mdi-upload</v-icon
              ><span v-else>{{ $t('component.upload.dropzone.drag.description') }}</span>
            </v-col>
          </v-row>
        </template>
        <span v-html="toolTip" />
      </v-tooltip>
    </v-card-title>
  </v-card>
</template>
<style lang="scss">
.vue-dropzone {
  border: 2px solid #e5e5e5;
  letter-spacing: 0.2px;
  color: var(--v-primary-base);
  transition: 0.2s linear;
  background-color: #f5f5f5 !important;
  border-radius: 5px;

  &:hover {
    border: 2px solid var(--v-primary-base);
  }
}
.dragenterClass {
  background-color: #000000;
  opacity: 0.5;
  border: 2px solid #01a8bb !important;
}
.rounded-card {
  border-radius: 40px;
}
.info-upload {
  width: 300px;
  height: 100px;
}
.input-field {
  visibility: hidden;
}
.mobile-btn-bottom {
  width: 120px !important;
}
.getDropZoneText {
  font-weight: 600 !important;
}
</style>
